// 事件 / 時間點的縮圖：進到畫面內才載；沒有縮圖（沒雲錄、環境沒開）就什麼都不畫。
// verify：先確認這一刻真的有雲端片段才拿縮圖（第七輪 B7-05：沒有片段的時間拿到一張花掉的縮圖）；
// 呼叫端已經知道有片段（事件清單的 has_clip）就不用。
// 固定大小的縮圖格（className thumb-slot，總覽警報列）：查完沒有縮圖寫「沒有縮圖」，不留空灰框（第十一輪 B11-08）。
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useThumbState, useSeen } from '../lib/thumbs';
import { cloudClipAtCached } from '../lib/facade';

export function EventThumb({
  api,
  homeId,
  device,
  atMs,
  alt,
  className,
  verify,
  lens = 0,
}: {
  api?: string;
  homeId: string;
  device: string;
  atMs: number;
  alt: string;
  className?: string;
  verify?: boolean;
  /** 多鏡頭：事件的鏡頭（副鏡頭抽副鏡頭片段的圖）。 */
  lens?: number;
}) {
  const [ref, seen] = useSeen<HTMLSpanElement>();
  const [ok, setOk] = useState<boolean | null>(verify ? null : true);
  useEffect(() => {
    if (!verify || !api || !seen) return;
    let alive = true;
    void cloudClipAtCached(api, homeId, device, Math.floor(atMs / 1000), lens).then((r) => alive && setOk(r === 'ok' || r === 'unknown'));
    return () => {
      alive = false;
    };
  }, [verify, api, homeId, device, atMs, seen, lens]);
  const { t } = useTranslation();
  const { url, settled } = useThumbState(api, homeId, device, atMs, seen && ok === true, lens);
  const slot = (className ?? '').split(' ').includes('thumb-slot');
  // 沒有可問的平台、這一刻沒有雲端片段、或問過了沒有圖
  const none = !url && (!api || ok === false || settled);
  return (
    <span ref={ref} className={`event-thumb ${className ?? ''} ${url ? 'has' : ''}${slot && none ? ' none' : ''}`} data-testid="event-thumb" data-none={slot && none ? '1' : undefined}>
      {url && <img src={url} alt={alt} loading="lazy" />}
      {slot && none && <span className="thumb-none">{t('events.no_thumb')}</span>}
    </span>
  );
}
